import { IContestType } from '@services/contest'

import { ContestType } from '@enums'

export const contestTypes = [
  {
    contestType: ContestType.PSSV,
    clearContestants: true,
    maxParticipants: 500,
    maxWinners: 3,
    minParticipants: 3,
    minVotes: 6,
    resetViewCount: true,
    resetVotes: true,
    rpkPrizePool: 500,
    submissionStopOnVoting: false,
    skipStartOffset: true,
    numberOfSeasons: 1,
    submissionStartOffsetTime: 0,
    contestResultOffsetTime: 100000,
  },
] as IContestType[]
